import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

const totalText = {
  margin: 0,
  fontWeight: 600,
  fontSize: '1rem',
  lineHeight: '1.5rem',
  color: neutral[100],
};

export default makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '3.5rem',
    padding: '1rem 0.75rem',
    backgroundColor: neutral[10],
    border: `1px solid ${neutral[20]}`,
    borderRadius: '0.5rem',
    boxShadow: '0 -0.375rem 0.875rem rgba(0,0,0,0.08)',
  },
  totalLabel: totalText,
  totalAmount: {
    ...totalText,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
});
